import { CoreBox, CoreTypography } from '@youscience/core';
import { Grid } from '@mui/material';
import { SxProps } from '@mui/system';

import { Breadcrumbs } from '@components/Breadcrumbs';
import { DEFAULT_BREADCRUMBS } from '@constants';
import { Breadcrumb } from '@interfaces';

import { StyledContainer, sxStyles } from './PageHeader.styles';

interface PageHeaderProps {
  children?: React.ReactNode;
  currentPage: string;
  title?: string;
  customBreadcrumbs?: Breadcrumb[];
  sx?: SxProps;
  buttons?: React.ReactNode[];
  hideBreadcrumbs?: boolean;
}

export const PageHeader = (props: PageHeaderProps) => {
  const { currentPage, title, children, customBreadcrumbs, hideBreadcrumbs = false } = props;
  const breadcrumbs = customBreadcrumbs || DEFAULT_BREADCRUMBS;

  return (
    <CoreBox sx={sxStyles.banner}>
      <StyledContainer sx={props.sx}>
        {!hideBreadcrumbs && <Breadcrumbs links={breadcrumbs} currentPage={currentPage} />}

        <Grid container sx={sxStyles.titleContainer}>
          <Grid item xs={8}>
            <CoreTypography variant="h4" sx={sxStyles.title}>
              {title || currentPage}
            </CoreTypography>
          </Grid>

          <Grid item xs={4} sx={sxStyles.actionButtons}>
            {props.buttons?.map((button) => button)}
          </Grid>
        </Grid>

        {children}
      </StyledContainer>
    </CoreBox>
  );
};
